export function parseHelpCenterFrontmatter(markdown: string): {
  attributes: Record<string, string>;
  body: string;
} {
  const match = markdown.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?/);
  if (!match) {
    return { attributes: {}, body: markdown };
  }

  const attributes: Record<string, string> = {};
  for (const line of match[1].split('\n')) {
    const separator = line.indexOf(':');
    if (separator === -1) {
      continue;
    }
    const key = line.slice(0, separator).trim();
    const value = line.slice(separator + 1).trim();
    if (key) {
      attributes[key] = value;
    }
  }

  return { attributes, body: markdown.slice(match[0].length) };
}

export function rewriteHelpCenterHref(href: string): string {
  if (!href) {
    return href;
  }
  if (/^(https?:|mailto:|#)/i.test(href)) {
    return href;
  }

  const hashIndex = href.indexOf('#');
  const hash = hashIndex >= 0 ? href.slice(hashIndex) : '';
  const pathPart = (hashIndex >= 0 ? href.slice(0, hashIndex) : href)
    .replace(/^\.\//, '')
    .replace(/^\//, '');

  if (!pathPart.endsWith('.md')) {
    return href;
  }

  const slug = pathPart.replace(/\.md$/, '').split('/').pop() ?? '';
  if (!slug) {
    return href;
  }
  return `/help-center/${slug}${hash}`;
}
